import { render } from "./ProductGroupValue.vue?vue&type=template&id=2a422a34&scoped=true"
import script from "./ProductGroupValue.vue?vue&type=script&lang=js"
export * from "./ProductGroupValue.vue?vue&type=script&lang=js"

import "./ProductGroupValue.vue?vue&type=style&index=0&id=2a422a34&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a422a34"]])

export default __exports__